import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-star-rating',
  templateUrl: './star-rating.component.html',
  styleUrls: ['./star-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StarRatingComponent {
  public _data: number;
  public blank: number;

  @Input()
  set data(data: number) {
    this._data = data;
    this.blank = 7 - data;
  }
}
